import {css} from 'lit';
export const styles = css`:host {
    font-weight: lighter;
}`;
export default styles;
